import React, { Component } from 'react'
import ConnectLink from '../components/ConnectLink'
import { popUp } from '../helpers'
import style from './style.styl'

const WORDPRESS_PLUGIN_URL = 'https://wordpress.org/plugins-wp/drift/'
const WORDPRESS_HELP_URL = 'https://help.drift.com/article/install-drift-on-your-wordpress-site/'

class WordPressInstaller extends Component {
  handleConnect = () => {
    popUp({ path: WORDPRESS_PLUGIN_URL })
  }

  render() {
    return (
      <div>
        {"1. Add the Drift plugin to your WordPress account and activate it."}
        <br/><br/>
        {'2. Copy the Javascript snippet from the section above. Navigate to the Drift plugin and paste the snippet where indicated. Make sure Drift (Live Chat) is set to Enabled.'}
        <br/> <br/>
        {'Need some help? Click '}
        <a className={style.Link} href={WORDPRESS_HELP_URL}>here</a>
        {' for more details!'}
        <br/><br/>
        <ConnectLink
          label="Download Wordpress Plugin"
          handleConnect={this.handleConnect}
          connectorType="button"
          buttonType="tertiary"
        />
      </div>
    )
  }
}

export default WordPressInstaller



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/WordPressInstaller.js